export default function converterDataParaFormatoISO(data: string): string {
  try {
    if (!data) return '';

    const match = data.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}:\d{2}:\d{2})/);

    if (!match) {
      throw new Error(
        `Formato de data inválido: "${data}". Esperado: dd/mm/yyyy hh:mm:ss`,
      );
    }

    const [, day, month, year, time] = match;
    const date = new Date(`${year}-${month}-${day}T${time}`);

    const tzOffset = date.getTimezoneOffset();
    const offset =
      (tzOffset > 0 ? '-' : '+') +
      String(Math.abs(Math.floor(tzOffset / 60))).padStart(2, '0') +
      ':' +
      String(Math.abs(tzOffset % 60)).padStart(2, '0');

    return date.toISOString().slice(0, -1) + offset;
  } catch (error) {
    console.error(error);
    return '';
  }
}
